import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type JournalistEnquiry from "./JournalistEnquiry";
import type { ErrorWithResponse } from "./types";
import type User from "./User";

@Model()
class JournalistEnquiryEvent extends ApplicationRecord {
  static jsonapiType = "journalist_enquiry_events";

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() event: Event;

  @Attr() eventAction: string;

  @BelongsTo() journalistEnquiry: JournalistEnquiry;

  @BelongsTo() user: User;
}

JournalistEnquiryEvent.afterFetch = (
  response,
  json: JSON & { message?: string }
) => {
  if (response.status === 401 && json.message === "sudo access required") {
    const error: ErrorWithResponse = new Error("sudo access required");
    error.response = Object.assign(response, { data: json });

    throw error;
  } else {
    ApplicationRecord.middlewareStack.afterFetch(response, json);
  }
};

export default JournalistEnquiryEvent;
